/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import Translator from "../../../utils/translator";

export class TranslationContextType {
    constructor (private readonly translator: Translator) {}

    /**
     * Will fetch translation from local storage in the language the translator currently has
     * @returns translation the resulting translation
     */
    get translate (): (sentence: string) => string {
        return this.translator.getLocalTranslation;
    }
}

export const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

export const useTranslationContext = (): TranslationContextType => {
    const context = useContext(TranslationContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the TranslationContext");
    }
    return context;
};